var map = {
	"./frame-creative.png": 2006,
	"./frame-img.png": 2007,
	"./frame-math.png": 2008,
	"./frame-pyt-nosnake.png": 2009,
	"./frame-pyt.png": 2010,
	"./frame.svg": 2011,
	"./start-bg.png": 1633
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2005;